// extracted by mini-css-extract-plugin
export default {"chart":"NewCustomer_chart__D9u1C","legend":"NewCustomer_legend__wAt46","indicator":"NewCustomer_indicator__kVESe","color":"NewCustomer_color__m-bHW"};